import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const ADMIN_ROLES = ["super_admin", "national_admin", "diocesan_admin", "community_coordinator", "store_manager"];

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) { navigate("/entrar", { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        const admin = ADMIN_ROLES.includes(data.role);
        navigate(admin ? "/admin" : "/o-meu-terco", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err.response?.data?.detail) || "Falha no login com Google");
        navigate("/entrar", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center bg-th-blue th-pattern" data-testid="auth-callback">
      <Logo size={54} />
      <p className="mt-4 text-white/80 text-sm">A concluir a autenticação…</p>
    </div>
  );
}
